import type { ExternalImageIdentifier } from '@atlaskit/media-client';

import { TEMPLATE_COVER_IMAGES, type TemplateCoverImageKey } from './types';

export const isTemplateImageCover = (fileId: string): boolean => {
  return fileId in TEMPLATE_COVER_IMAGES;
};

export const getTemplateImageCoverFileName = (fileId: string): string => {
  return TEMPLATE_COVER_IMAGES[fileId as TemplateCoverImageKey].fileName;
};

export const getTemplateImageIdentifier = (fileId: string): ExternalImageIdentifier => {
  const fileIdKey = fileId as TemplateCoverImageKey;
  const imageData = TEMPLATE_COVER_IMAGES[fileIdKey];
  return {
    mediaItemType: 'external-image',
    dataURI: imageData.imageSrc,
    name: imageData.fileName
  } as ExternalImageIdentifier;
};
